export enum AccountVerifyStatus {
  Pending = 'pending',
  Approved = 'approved',
  Rejected = 'rejected',
}
